import styled from 'styled-components';
import { motion } from 'framer-motion';
import {
  margin,
  flexbox,
  grid,
  display,
  MarginProps,
  GridProps,
  FlexboxProps,
  DisplayProps,
} from 'styled-system';

export const FlexRow = styled.div<FlexboxProps & GridProps & DisplayProps>`
  display: flex;
  ${flexbox};
  ${grid};
  ${display};
`;

export const Memo = styled(motion.div)<MarginProps>`
  width: 100%;
  ${margin};
`;
